import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { useGroups } from 'root/src/client/v2/auth/hooks/useGroups';
export function useIsAgency() {
    const { groups } = useGroups();
    return {
        isAgency: groups.includes(AuthGroup.AgencyAccountManager),
    };
}
